import { Button, Form, FormInstance, Row } from "antd";
import { useMemo, useState } from "react";
import { useSendForm } from "../../hooks/useSendForm";
import { FormSelect } from "./FormSelect";
import { useFetchData } from "../../hooks/useFetchData";
import { FormUpload } from "./FormUpload";
import { InfoCircleOutlined } from "@ant-design/icons";

type SendFormProps = {
  contractNumber: string;
};

export const SendForm = ({ contractNumber }: SendFormProps) => {
  const [form]: FormInstance[] = Form.useForm();

  const { isLoading, data } = useFetchData(contractNumber);

  const [isUploading, setIsUploading] = useState<boolean>(false);

  const { isLoading: isSending, send } = useSendForm(contractNumber, form);

  const file = Form.useWatch("file", form);

  const disabled: boolean = useMemo(
    () => isUploading || isSending || (file ? file.length === 0 : !file),
    [isUploading, isSending, file],
  );

  const templateId = Form.useWatch("templateId", form);

  return (
    <Row className="d-block">
      <h4 className="h h4 mb-1">Send Form</h4>
      <p className="text-md title mt-0">
        Fill in and securely send a form to us for processing.
      </p>
      <Form form={form} layout="vertical" requiredMark={false} className="mt-6">
        <FormSelect
          contractNumber={contractNumber}
          formItems={data}
          isLoading={isLoading}
          templateId={templateId}
        />
        {templateId && <FormUpload setIsUploading={setIsUploading} />}
      </Form>
      {file && file.length > 0 && (
        <Row className="mb-4 align-center">
          <InfoCircleOutlined className="mr-1" />
          <span>
            After submission, we'll review your form within 2 business days and
            send you an email notification.
          </span>
        </Row>
      )}
      {templateId && (
        <Button
          size="large"
          type="primary"
          shape="round"
          disabled={disabled}
          loading={isSending}
          onClick={send}
        >
          Send Form
        </Button>
      )}
    </Row>
  );
};
